.footer {
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  padding: var(--spacing-8) var(--spacing-16);
  border-top: 1px solid var(--stroke-neutral);
  font: var(--text-micro-regular);
  color: var(--text-tertiary);
  user-select: none;
}

.key {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--spacing-16);
  height: var(--spacing-16);
  padding: 0 var(--spacing-4);
  border-radius: var(--radius-4);
  background: var(--bg-tertiary);
  border: 1px solid var(--stroke-neutral);
  font: var(--text-micro-semibold);
  color: var(--text-secondary);
}

.text {
  margin-right: var(--spacing-4);
}

.dot {
  margin: 0 var(--spacing-4);
  opacity: 0.5;
}

.slash {
  opacity: 0.6;
}

/* Standard sr-only pattern — visually hidden but read by AT.
 * Used for the audible "or" between the J and K keycaps so
 * screen readers announce the pairing relationship. */
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

/* Unfocused-state prompt — replaces the keycap row in the same
   `.footer` slot. Inherits the wrapper's micro font + tertiary color;
   a single line so the footer height is identical to the keycap row. */
.prompt {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
